import { en } from "./en";
import { sq } from "./sq";
import { hr } from "./hr";

export const translations = {
  en,
  sq,
  hr,
};

export const getTranslation = (language, path) => {
  const keys = path.split(".");
  let value = translations[language] || translations.en;
  
  for (const key of keys) {
    if (value && typeof value === "object" && key in value) {
      value = value[key];
    } else {
      // Fallback to English if translation not found
      value = translations.en;
      for (const fallbackKey of keys) {
        if (value && typeof value === "object" && fallbackKey in value) {
          value = value[fallbackKey];
        } else {
          return path; // Return path if translation not found
        }
      }
      break;
    }
  }
  
  return value || path;
};

